import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';

import companiesLayout from './layout.json';
import WholesaleCompanyDialog from './WholesaleCompanyDialog';

class WholeSaleCompanyList extends React.Component {

  constructor( props ) {
    super( props );

    this.state = {
      row: {},
      showCompanyDialog: false
    };

    this.onIconClicked = this.onIconClicked.bind( this );
    this.onHandleClose = this.onHandleClose.bind( this );
    this.onHandleSave = this.onHandleSave.bind( this );
    this.onHandleClickNewItem = this.onHandleClickNewItem.bind( this );
  }

  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  onIconClicked( args ) {
    this.setState( {
      row: args.row,
      showCompanyDialog: true
    } );
  }

  onHandleClose( e ) {
    this.setState( {
      showCompanyDialog: false
    } );
  }

  onHandleSave( args ) {
    this.setState( {
      row: args.row
    } );
  }

  onHandleClickNewItem() {
    this.setState( {
      row: companiesLayout.section.newitem,
      showCompanyDialog: true
    } );
  }

  render() {
    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management']}>
        <ListContainer
          id="WholesaleCompanyList"
          layout={companiesLayout}
          selectedtab={1}
          row={this.state.row}
          onIconClicked={this.onIconClicked}
          onNewItem={this.onHandleClickNewItem}
        />
        <WholesaleCompanyDialog
          show={this.state.showCompanyDialog}
          onClose={this.onHandleClose}
          onSave={this.onHandleSave}
          row={this.state.row}
          activeKey={0}
        />
      </PageAuthorize>
    );
  }
}

export default WholeSaleCompanyList;



// WEBPACK FOOTER //
// ./src/content/wholesale/companies/components/CompanyList.js